'use client'

import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { PrevNextNav } from '@/components/molecules/Pager/PrevNextNav'

import { useNetworkWizardNav } from './NetworkWizardNavContext'

export const NetworkNewWizardStepNav = () => {
  const { t } = useTranslation()
  const { goNext, goPrev, submitting, isFirstStep, isLastStep } =
    useNetworkWizardNav()

  return (
    <Flex justify="center" pt={{ base: 4, md: 6 }}>
      <PrevNextNav
        prev={
          isFirstStep
            ? undefined
            : {
                onClick: goPrev,
                disabled: submitting,
                title: t('global:previous'),
              }
        }
        next={{
          onClick: goNext,
          loading: submitting,
          disabled: submitting,
          title: isLastStep ? t('networks.wizard.launch') : t('global:next'),
        }}
      />
    </Flex>
  )
}
